import React, { useEffect, useState,  useContext, useRef} from "react";
import { Modal } from "react-bootstrap";

import * as formato from '../JS/formato';
// import apps from "../assets/img/categoria.svg";
import ConexContext from "../../context/ConexContext";
import cerrar from "../../assets/img/cerrar.svg";
import icon1 from "../../assets/img/icon1.svg";
import ticket from "../../assets/img/ticket.png";
import uploadimg2 from "../../assets/img/uploadimg2.svg";

const ModalSubirImagenes = (props) => {
  // CONEX
  const conex=useContext(ConexContext);

  // STATESç
  const [Subida, setSubida]=useState(false);
  const [ErrorArchivo, setErrorArchivo]=useState("");
  const [ErrorImporte, setErrorImporte]=useState("");
  const [ErrorComentario, setErrorComentario]=useState("");
  const [state, setState]=useState({
    file: "",
    base64URL: "",
    importe: "",
    importe_BD: "",
    comentario: "",
    valError: "",
    ErrorFinal: false
  });

  // REFS
  const rImporte = useRef();
	const rDescripcion = useRef();
   //***************************FALTA POR ARREGLARLO***************************
  const cargarImagenBD2=async()=>{
    if(!state.file && !state.base64URL) return
    if (props.auxiliar){
      let res=await conex.peticion(`/cargaryvincularimagen`, {method:'POST',json: {base64: state.file.base64, nombre: state.file.name, importe: valorNum(state.importe), comentario: state.comentario, id_operacion: props.id_operacion, id_cod_ent:props.id_cod_ent}});
      if(res?.estado??true){
        setState({...state,valError:'No se ha podido subir la imagen correctamente'})
        return
      } 
      setSubida(true);
      setTimeout(() => {
        // Aquí puedes colocar el código que deseas ejecutar después de 2 segundos
        setSubida(false);
        props.setmodalSubirImagnesAux(true);
        cierra();
      }, 750);
    }else{
      let res=await conex.peticion(`/cargarimagen2`, {method:'POST',json: {base64: state.file.base64, nombre: state.file.name, importe: valorNum(state.importe), comentario: state.comentario}});
      if(res?.estado??true){
        setState({...state,valError:'No se ha podido subir la imagen correctamente'})
        return
      } 
      setSubida(true);

      setTimeout(() => {
        // Aquí puedes colocar el código que deseas ejecutar después de 2 segundos
        setSubida(false);
      }, 2000);
    }    
  }
  // FUNCIONES
  // Para cerrar el modal
  function cierra() {
    let aux={...state};
    aux.file="";
    aux.base64URL="";
    aux.importe= "";
    aux.importe_BD= "";
    aux.comentario= "";
    aux.valError="";
    aux.ErrorFinal=false;
    setState(aux);
    setSubida(false);
    props.onHide();
    setErrorArchivo("");
    setErrorImporte("");
    setErrorComentario("");
  }
  //funcion que devuelve el valor del campo moneda, sin formato
	function valorNum(val){
		val=(val.slice(-1)==='€'?val.slice(0,-1):val)//quitamos los posibles símbolos
		val=val.replace(/\./g,''); //quitamos los posibles separadores de miles
		val=val.replace(/,/g,'.'); //ponemos el sep. de decimal que le gusta a javascript
		return(val*1)
	}
	function alFoco(){
    setErrorImporte("");
		if (rImporte.current.value==='') 
			return;
		let val=valorNum(rImporte.current.value)
		if (!Number.isNaN(val))
			rImporte.current.value=val
		rImporte.current.select()
	}
	function alNoFoco(){
    setErrorImporte("");
		if (rImporte.current.value==='')
			return;
		let val
    val=formato.formatNum(rImporte.current.value,'€','.',2)
    if (Number.isNaN(val))
      setState({...state,valError:'Formato numérico incorrecto'})
    else
      setState({...state,importe:val, importe_BD:rImporte.current.value, valError:''})
		
	}  
  // Effec para cada vez que abre y cierra el modal
  useEffect(() => {
    //Se acaba de abrir
    if(props.show){
    }
  }, [props.show]);
  const getBase64 = file => {
    return new Promise(resolve => {
    //   let fileInfo;
      let baseURL = "";
      // Hacer un nuevo FileReader
      let reader = new FileReader();

      // Convierta el archivo a texto base64
      reader.readAsDataURL(file);

      // en el lector carga algo...
      reader.onload = () => {
        // Hacer un fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };
  const handleFileInputChange = (e) => {
    setErrorArchivo("");
    const file_aux = e.target.files[0]; // Obtener el archivo seleccionado

    if (file_aux) {
      const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      
      if (!validImageTypes.includes(file_aux.type)) {
        setErrorArchivo("Solo se permiten imágenes (JPG, PNG, GIF, WEBP). Por favor, seleccione de nuevo un archivo válido.");
        e.target.value = ""; // Resetear el input
        return;
      }
      // Si el archivo es válido, puedes continuar con la lógica de carga
      setSubida(false);
      let { file } = state;
      file = e.target.files[0];
      getBase64(file)
        .then(result => {
          file["base64"] = result;
          setState({...state, 
            base64URL: result,
            file: file
          });
        })
        .catch(err => {
          setErrorArchivo(err);
        });
      setState({
        file: e.target.files[0]
      });
    }
  };

  if (!props.show)
  	return("")
  else
  return (
    <Modal
      className="modal_campos modal_subirimages"
      show={props.show}
      onHide={props.onHide}
      animation={false}
      centered
    >
      <div id="modalcampos" ref={props.referencia}>
        <Modal.Body>
            <div className="contmodal fondoazul modales_campos col-xs-12">
                <div className="col-xs-12 nopadding" >
                    <div className="col-xs-6 titular_modal mt-n1 nopadding">
                        <img src={icon1} alt="icono" className="icocampos" />
                        <h2>Subir imágenes</h2>
                    </div>
                    <div className="col-xs-6 contaspacierre nopadding">
                        <div
                            onClick={() => {
                            cierra();
                            }}
                            className="aspacierre"
                        >
                        <img src={cerrar} alt="cerrar" className="icocerrar" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xs-12 ticket">
              {state.base64URL==="" && state.file==="" &&
                <div className="col-xs-12 sinticket">

                  <input id="fileinput" className="custom-file-input" value={state.file} type="file" accept="image/*" onChange={(e)=>{handleFileInputChange(e)}}></input>
                  Seleccione una imagen
                </div>
              }
              <img src={state.base64URL==="" ? (ticket):(state.base64URL)} alt="ticket"/>           
            </div>
            <div className="col-xs-12 subtitular_ticket">
              <h4>Datos opcionales:</h4>
            </div>
            <input 
              className="form-control" 
              placeholder="Importe" 
              type="Importe" 
              id="inputPassword" 
              value={state?.importe??""}
              ref={rImporte}
              onFocus={()=>{alFoco()}}
							onBlur={()=>{alNoFoco()}}
              onChange={()=>{
                setSubida(false);
                setState({...state,importe:rImporte.current.value, ErrorFinal:false})
              }}
              maxLength={7}
            />
            <div className='error col-xs-12'>
								<span>
								{state===null?'':state.valError}
								</span>
						</div>
            <textarea 
              className="form-control" 
              placeholder="Comentario" 
              type="Comentario"             
              id="inputComentario" 
              value={state?.comentario??""}
              ref={rDescripcion}
              maxLength={32}
              onChange={()=>{
                setErrorComentario("");
                setSubida(false);
                let aux={...state};
                aux.comentario=rDescripcion.current.value;
                aux.ErrorFinal=false;
                setState(aux);
              }}
            />
          <button
          className={state.file ? ("aplicar_imagen"):("aplicar_imagen desactiva")}
          onClick={() => {
            if(state.valError!==''){
              setState({...state, ErrorFinal:true})
              return
            } 
            const importeStr = state.importe
            .replace('€', '')     // elimina símbolo €
            .replace('.', '')     // si hay separador de miles
            .replace(',', '.')    // convierte coma decimal a punto
            .trim();
          const importe = parseFloat(importeStr);
          if (importe < 0) {
            setErrorImporte("No se pueden subir tickets con valores negativos")
            return
          }
          if (state.comentario.length>32){
            setErrorComentario("No se pueden subir tickets con comentarios con mas de 32 caracteres")
            return
          }
            if(state.file==="") return
            cargarImagenBD2();
            
            let aux={...state};
            aux.file="";
            aux.base64URL="";
            aux.importe= "";
            aux.comentario= "";
            aux.importe_BD= "";
            aux.ErrorFinal=false;
            setState(aux);
            // props.onHide();
          }}
        >
          {props.auxiliar ? ("Guardar y vincular ticket"):("Guardar ticket")}
          <img src={uploadimg2} alt="subirimagen" className="btn_subir" />
        </button>
        <div className='error col-xs-12'>
								<span>
								{/* {state.ErrorFinal===false?'':'No puede subir la imagen, hay errores en los datos'} */}
                {ErrorArchivo && ErrorArchivo}
                {ErrorImporte && ErrorImporte}
                {ErrorComentario && ErrorComentario}
								</span>
				</div>
        {Subida && 
        <div className='error col-xs-12 verde'>
        <span>
        { <p>"Imagen subida con éxito"</p>}
        { <i className="fa-solid fa-check verde"> </i>}
        </span>
        </div>
        }
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default ModalSubirImagenes;
